export const enumUrl = {
  login: "api/auth/login",
  register: "api/auth/register",
  user: "api/user",
  form: "api/form",
  report: "api/report",
  upload: "api/form/upload",
  streets: "api/street",
};

export async function download(blob, fileName) {
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
}

export function getRoles(role) {
  if (role === "user")
    return {
      id: 2,
      label: "Utilizator",
    };
  else if (role === "admin") return { id: 1, label: "Administrator" };

  if (role === 1) return "admin";
  else if (role === 2) return "user";
}
